export interface ICurrency {
  code: string;
  name: string;
  exponential: number;
  formattedName?: string;
}
